import { CancelToken } from 'axios';

import {
    fetchProduct,
    fetchProductSearch,
    fetchProductAutocomplete,
    addToCart,
    getCartInactive,
    removeProduct,
    updateProductQty,
} from 'helpers/api';
import { isProd } from 'config/config';
import { formatMoney, toggleLoading, sellPackRounding } from 'helpers/utils';
import { updateCartTotal, getCart } from './sidecart';
import { updateAllowableFreight } from './allowable-freight-promo';
import { handleAddNoteToggle } from './checkout-cart';

const _search = document.getElementsByClassName('js--ob-search')[0];
const _dropdown = document.getElementsByClassName('js--ob-search-dropdown')[0];
const _clear = document.getElementsByClassName('js--ob-clear')[0];
const _qty = document.getElementsByClassName('js--ob-qty')[0];
const _cart = document.getElementsByClassName('js--ob-cart')[0];
const _total = document.getElementsByClassName('js--ob-total')[0];
const _totals = Array.from(document.getElementsByClassName('js--ob-total'));
const _searchAtcBtn = document.getElementsByClassName('js--ob-search-atc')[0];
const activeClass = 'ob__searchcard--active';
const imagePath = isProd ? 'assets' : 'images';

// eslint-disable-next-line
let fetchProductsTimeout = null;
let noItems = null;
let sellpack = 1;
let activeProductID = null;
let activeProduct = {};
let order = {};
let didYouMean = false;
let isFetching = false;
let source = null;
let stopDropdown = false;
let updatingLineItem = false;
let invalid = '';
let updateSearchValue = '';
let orderDisplacement = 0;

// ==================================================
// INITIALIZERS
// ==================================================

async function displayInactiveCartItems() {
    const inactiveItems = await getCartInactive();
    let total = 0;

    if (!inactiveItems.length) {
        toggleLoading();
        return (document.getElementsByClassName('js--no-items')[0].innerHTML =
            'No Items Selected.');
    }

    const html = inactiveItems
        .map((k, i) => {
            const product = { ...k.Product, qty: k.Quantity };
            total += k.Quantity * k.Product.ActualCost;
            order[k.Product.CartItemId] = { ...product, order: i };
            return `<li>${item({ ...product, displayNoteEdit: true })}</li>`;
        })
        .reverse()
        .join('');

    _cart.innerHTML = '';
    _cart.appendChild(noItems);
    _cart.innerHTML = _cart.innerHTML.concat(html);
    updateTotals(formatMoney(total));
    _search.focus();

    handleNoItemsDisplay();
    toggleLoading();
    setNoteEventListeners();
    setATCEventListeners();
}

function setNoteEventListeners(el = null) {
    const container = el || document;

    // add note toggle event listeners
    Array.from(container.getElementsByClassName('js--add-note')).forEach((k) =>
        k.addEventListener('click', (e) => handleAddNoteToggle(e)),
    );

    // cancel note event listeners
    Array.from(container.getElementsByClassName('js--note-cancel')).forEach((k) =>
        k.addEventListener('click', (e) => handleAddNoteToggle(e, false)),
    );

    // save note event listeners
    Array.from(container.getElementsByClassName('js--note-save')).forEach((k) =>
        k.addEventListener('click', (e) => {
            handleSaveNote(e);
            handleAddNoteToggle(e, false);
        }),
    );

    Array.from(container.getElementsByClassName('js--ob-remove')).forEach((k) =>
        k.addEventListener('click', (e) => removeItem(e)),
    );

    Array.from(container.getElementsByClassName('js--ob-li-qty')).forEach((k) =>
        Array.from(['keyup', 'focusout']).forEach((j) =>
            k.addEventListener(j, (e) => updateLineItemQty(e)),
        ),
    );
}

function setATCEventListeners(el = null) {
    const container = el || document;
    Array.from(container.getElementsByClassName('js--upload-add')).forEach((k) =>
        k.addEventListener('click', (e) => addProductToCart(e.target.getAttribute('data-id'))),
    );
}

async function handleSaveNote(e) {
    const { target } = e;
    const container = e.target.closest('li');
    const note = target.closest('.js--li-body').getElementsByClassName('js--note-body')[0].value;
    const { Product, Quantity } = await updateProductQty({
        cartItemId: target.getAttribute('data-id'),
        qty: target.getAttribute('data-qty'),
        note,
    });

    e.target.closest('li').innerHTML = item({
        ...Product,
        qty: Quantity,
        PartNote: note,
        displayNoteEdit: true,
    });

    setNoteEventListeners(container);
    setATCEventListeners(container);
}

// ==================================================
// SEARCH FIELD
// ==================================================

export async function handleKeys(e) {
    e.preventDefault();

    if (!_dropdown.children.length) {
        return;
    }

    const current = document.querySelector(`.${activeClass}`);
    const items = document.getElementsByClassName('ob__searchcard');
    let next;

    if (e.keyCode === 40 && current) {
        next = current.nextElementSibling || items[0];
    } else if (e.keyCode === 40) {
        const [nextItem] = items;
        next = nextItem;
    } else if (e.keyCode === 38 && current) {
        next = current.previousElementSibling || items[items.length - 1];

        if (!next.classList.contains('js--ob-sc')) {
            next = items[items.length - 1];
        }
    } else if (e.keyCode === 38) {
        next = items[items.length - 1];
    } else if (e.keyCode === 13) {
        return _qty.focus();
    }

    if (e.type === 'mouseenter') {
        next = e.target;
    }

    if (current) {
        current.classList.remove(activeClass);
        updateSearchValue = '';
    }

    next.classList.add(activeClass);
    activeProductID = parseInt(next.getAttribute('data-id'), 10);
    updateSearchValue = next.getAttribute('data-part');
}

export function handleDropdownClick(e) {
    activeProductID = e.target.closest('.js--ob-sc').getAttribute('data-id');
    clearSearchDropdown();
    _qty.focus();
}

async function getDidYouMean(value) {
    didYouMean = true;
    isFetching = true;

    if (!_dropdown.classList.contains('ob__search__dropdown-wrapper--active')) {
        toggleSpinner();
    }

    const res = await fetchProductSearch(value).catch(() => []);
    console.log(res);
    isFetching = false;

    if (res.length) {
        updateDropdown(res);
    } else {
        invalid = value;
        toggleInvalidPart();
        _search.focus();
    }

    toggleSpinner(true);
}

function updateDropdown(items) {
    const products = items.map(({ Product }, i) => searchCard(Product, i)).join('');
    console.log(products);
    activeProductID = items.length === 1 ? items[0].Product.Id : null;
    activeProduct = items[0].Product;
    didYouMean = false;

    if (!_dropdown.classList.contains('ob__search__dropdown-wrapper--active')) {
        _dropdown.classList.add('ob__search__dropdown-wrapper--active');
    }

    _dropdown.innerHTML = products;

    if (items.length === 1) {
        _dropdown.getElementsByClassName('js--ob-sc')[0].classList.add(activeClass);
    }

    Array.from(document.getElementsByClassName('js--ob-sc')).forEach((k) =>
        k.addEventListener('mouseenter', (e) => handleKeys(e)),
    );

    _search.focus();
}

export function handleChange(e, altPart = false) {
    e.preventDefault();

    if (e.type === 'change') {
        updateSearchWithSelectedValue();
    }

    if (
        !e.keyCode >= 96 &&
        e.keyCode <= 105 &&
        !/[a-zA-Z0-9-_ ]/.test(String.fromCharCode(e.keyCode)) &&
        !altPart
    ) {
        return (updateSearchValue = '');
    }

    if (invalid !== _search.value && invalid.length) {
        toggleInvalidPart(true);
    }

    if ([9, 37, 39].indexOf(e.keyCode) !== -1 && !altPart) {
        return;
    }

    if (e.type === 'keyup' || altPart) {
        stopDropdown = false;
        didYouMean = false;
        activeProductID = null;
    }

    if (typeof e.keyCode === 'undefined' && activeProductID && !altPart) {
        return _qty.focus();
    }

    const value = altPart ? _search.value : e.target.value;

    // if (mfCode) {
    //   value = `${mfCode}, ${value}`
    // }

    fetchProductsTimeout = setTimeout(async () => {
        source = CancelToken.source();
        isFetching = true;
        let res = await fetchProductAutocomplete(value, source);
        isFetching = false;
        source = null;

        // if (mfCode && mfCode !== ' ') {
        //   res = res.filter((k) => k.Product.ManufacturerCode === mfCode)
        // }

        if (
            res === 204 ||
            stopDropdown ||
            (res.length === 1 && activeProduct && res[0].Product.Id === activeProduct.Id)
        ) {
            return;
        }

        if (!res.length) {
            res = await fetchProductAutocomplete(value);

            _dropdown.classList.remove('ob__search__dropdown-wrapper--active');
            _dropdown.innerHTML = '';

            clearSearchDropdown();
            return;
        }

        const products = res.map(({ Product }, i) => searchCard(Product, i)).join('');
        activeProductID = res.length === 1 ? res[0].Product.Id : null;
        activeProduct = res[0].Product;

        if (!_dropdown.classList.contains('ob__search__dropdown-wrapper--active')) {
            _dropdown.classList.add('ob__search__dropdown-wrapper--active');
        }

        _dropdown.innerHTML = products;

        Array.from(document.getElementsByClassName('js--ob-sc')).forEach((k) =>
            k.addEventListener('mouseenter', (e) => handleKeys(e)),
        );

        if (res.length === 1) {
            const selected = _dropdown.getElementsByClassName('js--ob-sc')[0];
            selected.classList.add(activeClass);
            updateSearchValue = selected.getAttribute('data-part');
        }
    }, 0);
}

// ==================================================
// QTY FIELD
// ==================================================

export function checkQtyVal(e) {
    e.target.value = e.target.value.replace(/[^\d+$]/g, '');
}

function updateSearchWithSelectedValue() {
    if (updateSearchValue.length) {
        _search.value = updateSearchValue;
        updateSearchValue = '';
    }
}

export async function checkForProductId() {
    stopDropdown = true;

    if (source) {
        source.cancel('Operation canceled by the user.');
    }

    if (isFetching) {
        return setTimeout(checkForProductId, 20);
    }

    const val = activeProductID || _search.value;

    if (!activeProductID && !val.length) {
        return _search.focus();
    }

    if (!activeProductID) {
        return getDidYouMean(val);
    }

    clearSearchDropdown();
}

export function qtyTabATC(e) {
    const { keyCode } = e;
    e.target.value = e.target.value.replace(/[^\d+$]/g, '');
    const qty = parseInt(e.target.value, 10);

    if (e.shiftKey && e.keyCode === 9) {
        return;
    }

    if ([9, 13].indexOf(keyCode) !== -1 && qty > 0) {
        e.preventDefault();
        _qty.blur();
        if (activeProductID > 0) {
            return orderItem({
                qty,
                id: activeProductID,
            });
        }

        _search.value = '';
        _qty.value = '';
        _search.focus();
    }
}

// ==================================================
// ORDER BUILDER LIST
// ==================================================

function handleNoItemsDisplay(hide = true) {
    const _noItemsLi = document.getElementsByClassName('js--ob-no-items')[0];
    const styleHide = 'ob--hide';

    if (_noItemsLi) {
        return hide ? _noItemsLi.classList.add(styleHide) : _noItemsLi.classList.remove(styleHide);
    }
}

async function orderItem({ id, qty }) {
    if (sellpack > 1) {
        qty = sellPackRounding(qty, sellpack);
        sellpack = 1;
    }

    toggleSpinner();
    const Product = await fetchProduct(id, qty);
    if (Product.CartItemId === 0) {
        Product.CartItemId = `NLA-${Product.Id}`;
    }

    order[Product.CartItemId] = {
        ...Product,
        ListPrice: Product.ListPrice,
        ActualCost: Product.ActualCost,
        order: orderDisplacement || 0,
    };
    orderDisplacement += 1;

    const productTotal = Product.IsNLA ? 0 : Product.ActualCost * Product.qty;
    updateListItems({
        total: productTotal,
        list: order,
    });
    toggleSpinner(true);
}

function listPart(e) {
    const id = e.target.getAttribute('data-id');
    const evt = document.createEvent('Event');

    evt.initEvent('change', false, true);
    _search.value = id;
    _search.dispatchEvent(evt);
    _search.focus();
    handleChange(evt);
}

// ==================================================
// ADD TO CART
// ==================================================

export function productATC() {
    if (!activeProductID) {
        return _search.focus();
    }

    const qty = parseInt(_qty.value, 10);

    if (qty < 1) {
        return _qty.focus();
    }

    if (activeProductID > 0) {
        _search.value = '';
        _qty.value = '';
        return orderItem({
            qty,
            id: activeProductID,
        });
    }
}

async function addProductToCart(cartItem = false) {
    const cartOrder = [];

    if (cartItem) {
        cartOrder.push({
            cartItemId: order[cartItem].CartItemId,
            qty: order[cartItem].qty,
            note: order[cartItem].PartNote || null,
        });
    } else {
        Object.keys(order).forEach((k) => {
            if (k.indexOf('NLA') === -1) {
                cartOrder.push({
                    cartItemId: order[k].CartItemId,
                    qty: order[k].qty,
                    note: '',
                });
            }
        });
    }

    const res = await addToCart(cartOrder);
    updateCartTotal({
        count: res.QuantityCount,
        total: res.CartTotal,
    });

    if (cartItem && Object.keys(order).length > 1) {
        document.querySelector(`div[data-line-item="${order[cartItem].Id}"`).parentNode.remove();
        delete order[cartItem];
    } else {
        clearItems(true);
    }

    getCart();
    updateAllowableFreight();
}

// ==================================================
// HANDLERS
// ==================================================

function updateListItems({ total, list }) {
    const oldTotal = parseFloat(_total.innerHTML.replace(/[^\d.+]/g, ''), 10) || 0;
    const newTotal = (total + oldTotal).toFixed(2);
    const html = Object.keys(list)
        .sort((a, b) => list[b].order - list[a].order)
        .map((k) => `<li>${item({ ...list[k], displayNoteEdit: true })}</li>`)
        .join('');

    didYouMean = false;
    _cart.innerHTML = '';
    _cart.appendChild(noItems);
    _cart.innerHTML = _cart.innerHTML.concat(html);
    updateTotals(formatMoney(newTotal));

    const _liQty = Array.from(document.getElementsByClassName('js--ob-li-qty'));
    _liQty.forEach((k) => {
        k.addEventListener('keyup', (e) => {
            checkQtyVal(e);
            qtyTabATC(e, true);
        });
    });

    setATCEventListeners();
    setNoteEventListeners();
    resetFields();
}

export function resetFields() {
    const container = document.getElementsByClassName('js--order-builder')[0].classList;
    handleNoItemsDisplay();
    resetPartFields();
    _search.value = '';
    _qty.value = '';
    activeProductID = null;
    activeProduct = null;

    if (container.contains('warranty--container-error')) {
        container.remove('warranty--container-error');
    }
}

function updateTotals(total) {
    _totals.forEach((k) => (k.innerHTML = `${total}`));
}

async function updateLineItemQty(e) {
    if (updatingLineItem) {
        return;
    }

    updatingLineItem = true;
    checkQtyVal(e);

    if (e.type !== 'keyup' || e.keyCode === 13) {
        const container = e.target.closest('li');
        const note = container.getElementsByClassName('js--upload-note');
        const { Product, Quantity } = await updateProductQty({
            cartItemId: e.target.getAttribute('data-id'),
            qty: e.target.value,
            note: note ? note[0].innerHTML : '',
        });

        container.innerHTML = item({
            ...Product,
            qty: Quantity,
            PartNote: note ? note[0].innerHTML : null,
            displayNoteEdit: true,
        });
        order[Product.CartItemId] = { ...Product, qty: Quantity };
        getTotal();
        setNoteEventListeners(container);
        setATCEventListeners(container);
    }
    updatingLineItem = false;
}

function getTotal() {
    let total = 0;
    Object.values(order).forEach((k) => {
        total += k.ActualCost * k.qty;
    });

    updateTotals(formatMoney(total));
}

// ==================================================
// RESET / CLEAR / REMOVE
// ==================================================

function resetPartFields() {
    activeProductID = null;
    activeProduct = null;
    clearSearchDropdown();

    _qty.value = '';
    _search.value = '';
    _search.focus();
}

function clearItems(reset = false) {
    const noItems = _cart.getElementsByClassName('js--ob-no-items')[0].cloneNode(true);
    noItems.innerHTML =
        '<div class="ob__results__item"><p class="js--no-items">No Items Selected.</p></div>';
    const cartIds = Object.keys(order);
    order = {};
    _cart.innerHTML = '';
    _cart.appendChild(noItems);
    _search.value = '';
    _qty.value = '';
    _totals.forEach((k) => (k.innerHTML = '$0.00'));
    handleNoItemsDisplay(false);
    _search.focus();

    if (!reset) {
        removeProduct(cartIds, 'create-order-builder:clearItems');
    }
}

function clearSearchDropdown() {
    _dropdown.classList.remove('ob__search__dropdown-wrapper--active');
    _dropdown.innerHTML = '';
}

function removeItem(e) {
    const target = e.target.nodeName === 'I' ? e.target.closest('button') : e.target;

    if (!target.classList.contains('js--ob-remove')) {
        return;
    }

    const cartId =
        target.tagName.toLowerCase() === 'button'
            ? target.getAttribute('data-id')
            : target.closest('button').getAttribute('data-id');

    if (Object.keys(order).indexOf(cartId) !== -1) {
        const total = order[cartId].IsNLA ? 0 : order[cartId].qty * order[cartId].ActualCost * -1;
        delete order[cartId];
        orderDisplacement += 1;

        removeProduct(cartId, 'create-order-builder:removeItem');

        return Object.keys(order).length
            ? updateListItems({
                total,
                list: order,
            })
            : clearItems();
    }
}

// ==================================================
// HELPERS
// ==================================================

export function toggleSpinner(hide) {
    const spinner =
        document.getElementsByClassName('js--spinner')[1] ||
        document.getElementsByClassName('js--spinner')[0];

    if (hide) {
        spinner.classList.add('ob__spinner--opacity');
        return setTimeout(() => spinner.classList.add('ob__spinner--hidden'), 210);
    }

    spinner.classList.remove('ob__spinner--hidden');
    spinner.classList.remove('ob__spinner--opacity');
}

export function toggleInvalidPart(hide) {
    if (hide) {
        return document
            .getElementsByClassName('js--invalid-part')[0]
            .classList.add('ob__invalid-part--hidden');
    }
    document
        .getElementsByClassName('js--invalid-part')[0]
        .classList.remove('ob__invalid-part--hidden');
}

// ==================================================
// HTML REPEATERS
// ==================================================

function searchCard({ ManufacturerCode, PartNumber, Description, Id }, i) {
    const didYouMeanEl = `
    <div class="ob__searchcard__didyoumean">
      <p>Did You Mean?</p>
    </div>`;

    const card = `
  <div class="js--ob-sc ob__searchcard" data-id="${Id}" data-part="${ManufacturerCode}, ${PartNumber}">
    <p class="ob__searchcard__title"><span>${ManufacturerCode},</span> <span class="ob__searchcard__focus">${PartNumber}</span></p>
    <p class="ob__searchcard__description">${Description}</p>
  </div>`;

    return didYouMean && i === 0 ? didYouMeanEl.concat(card) : card;
}

export function item({
    PartNumber,
    ManufacturerCode,
    Description,
    ListPrice,
    ActualCost,
    Id,
    CartItemId,
    qty,
    Availability,
    StatusMessage,
    IsNLA,
    FullPartNumber,
    AlternateParts,
    BackorderQuantity,
    SmartshipQuantity,
    ETADate,
    PartNote = '',
    FreightNotes,
    Supersedes,
    PackageNotes = '',
    review = false,
    del = true,
    upload = false,
    displayNoteEdit = false,
    viewNote = false,
    AlternateWarehouseId,
    AlternateWarehouseNote,
    IsProhibitedState,
    RestrictedPartNote
}) {
    const total = formatMoney(parseFloat(ActualCost, 10) * qty);
    const statusTypes = {
        available:
            '<i class="fas fa-check success ob--center ob__results__icon" aria-hidden="true"></i>',
        smartship: `<img class="ob--center ob__results__icon" src="/${imagePath}/smartship.png" />`,
        backorder:
            '<i class="fas fa-exclamation-triangle alert ob--center ob__results__icon" aria-hidden="true"></i>',
    };

    qty = qty < 1 ? 1 : qty;
    PartNote = !PartNote || PartNote === 'null' ? '' : PartNote;
    let status = statusTypes.available;

    if (Availability !== 100) {
        status = Availability === 200 ? statusTypes.smartship : statusTypes.backorder;
    }

    if (!review) {
        return `
    <div class="js--line-item ob__results__item" data-line-item="${Id}">
      <button class="js--ob-remove ob__results__remove-btn" data-id="${CartItemId}">
        <i class="fas fa-times" aria-hidden="true"></i>
      </button>
      <div class="ob__results__li ob--justify-start" data-label="Part #">${PartNumber}</div>
      <div class="ob__results__li ob--tc" data-label="Qty.">
        ${!IsNLA
                ? `<input tabindex="-1" class="ob--center js--ob-li-qty" type="text" name="qty" value="${qty}" data-id="${CartItemId}">`
                : ''
            }
      </div>
      <div class="ob__results__li" data-label="Availability">
        ${!IsNLA ? status : ''}
      </div>
      <div class="ob__results__li ob__results--flex3 ob--justify-start" data-label="Description">
        <div class="js--li-body" data-id="${CartItemId}">
          <p class="ob__results__text">
          <span class="ob__results--bold">${ManufacturerCode}, ${PartNumber}</span>${Description}</p>
            ${Supersedes && Supersedes.length > 0
                ? `<p class="ob__results__text"><span class="ob__results--bold">Part Superseded From: </span>${Supersedes}</p>`
                : ''
            }
          ${AlternateParts && AlternateParts.length > 0
                ? `<p class="ob__results__text ob__alt-parts">
            <span class="ob__results--bold">Alt. Parts: </span>${AlternateParts.map(
                    ({ m_Item1, m_Item2 = null }) =>
                        `<button class="ob__alt-parts__btn ${upload ? 'ob__alt-parts__upload' : ''
                        } js--alt-parts" data-id="${m_Item1}">${m_Item1}${m_Item2 !== null ? ` (${m_Item2})` : ''
                        }</button>`,
                ).join('')}</p>`
                : ''
            }
            ${FreightNotes && FreightNotes.length > 0
                ? `<span class="ob__results--bold">Note: </span>${FreightNotes}</p>`
                : ''
            }
            ${StatusMessage && StatusMessage.length > 0
                ? `<p class="ob__results__text"><span class="ob__results--bold">Warning: </span>${StatusMessage}</p>`
                : ''
            }
            ${IsProhibitedState && RestrictedPartNote.length > 0
                ? `<p class="ob__results__text" style="font-style: italic;color: red;"><span class="ob__results--bold">Warning: </span>${RestrictedPartNote}</p>`
                : ''
            }
          ${PackageNotes && PackageNotes.length > 0
                ? `<p class="ob__results__text"><span class="ob__results--bold">Package Notes: </span>${PackageNotes}</p>`
                : ''
            }
          ${AlternateWarehouseNote && AlternateWarehouseNote.length > 0
                ? `<p class="ob__results__text"><span class="ob__results--bold">Note: </span>${AlternateWarehouseNote}</p>`
                : ''
            }
          ${displayNoteEdit && !IsNLA
                ? `<p class="ob__results__text js--note-added ${PartNote.length ? '' : 'none'
                }"><span class="ob__results--bold">Part Notes: </span><span class="js--upload-note">${PartNote}</span><button class="ob__results__edit js--add-note"><i class="fas fa-pencil-square-o" aria-hidden="true"></i></button></p>
              <button class="ob__results__text ob__results__button js--add-note ${PartNote.length ? 'none' : ''
                }">Add Individual Part Notes</button>`
                : ''
            }
          <div class="ob__results__note-container none js--note">
            <textarea class="ob__results__textarea js--note-body" placeholder="Enter Part Note" data-id="${CartItemId}">${PartNote.length ? PartNote : ''
            }</textarea>
            <p class="ob__results__text ob__results__note-options">
              <button class="ob__results__button ob__results__cancel js--note-cancel">Cancel</buttonclass>
              <button class="ob__results__button ob__results__save js--note-save" data-qty="${qty}" data-id="${CartItemId}">Save</button>
            </p>
          </div>
        </div>
      </div>
      <div class="ob__results__li" data-label="List">${!IsNLA ? `${formatMoney(ListPrice)}` : ''
            }</div>
      <div class="ob__results__li" data-label="Cost">${!IsNLA ? `${formatMoney(ActualCost)}` : ''
            }</div>
      <div class="ob__results__li js--li-total" data-label="Total" data-cost="${ActualCost}">${!IsNLA ? `${total}` : ''
            }</div>
    <div class="ob__results__li" data-label="Add to Cart">
    ${!IsNLA
                ? `<button class="ob__results__upload js--upload-add" data-id="${CartItemId}">
          <i class="fas fa-shopping-cart js--upload-add" aria-hidden="true"></i>Add to Cart
        </button>`
                : ''
            }
      </div>
    </div>`;
    }

    return `
    <div class="ob__results__item">
      <div class="ob__results__li" data-label="Availability"><div class="ship-methods">
        <div class="order-avail order_sh${qty - SmartshipQuantity - BackorderQuantity > 0 ? '' : ' hide-method'
        }">
          <div class="availability-memo">
            <span>${qty - SmartshipQuantity - BackorderQuantity} Items available</span>
            <span class="dn-angle"></span>
          </div>
          <i aria-hidden="true" class="ob__overview__icon success fa fa-check"></i>
        </div>
        <div class="order-avail order_ss${SmartshipQuantity > 0 ? '' : ' hide-method'}">
          <div class="availability-memo">
            <span>${SmartshipQuantity} Items Available Via Enhanced Shipping</span>
            <span class="dn-angle"></span>
          </div>
          <img src="/assets/smartship.png" class="ob__overview__icon">
        </div>
        <div class="order-avail order_ooo${BackorderQuantity > 0 ? '' : ' hide-method'}">
          <div class="availability-memo">
            <span>${BackorderQuantity} Items Backordered</span>
            <span class="dn-angle"></span>
          </div>
          <i aria-hidden="true" class="ob__overview__icon alert fa fa-exclamation-triangle"></i>
        </div>
        <div class="order-avail order_ooo ${AlternateWarehouseId > 0 ? '' : ' hide-method'} ">
        <div class="availability-memo-alt-warehouse">
          <span>All shipments for any items sourced from an alternate warehouse will be charged actual freight charges</span>
          <span class="dn-angle"></span>
        </div>
        <i aria-hidden="true" class="ob__overview__icon fa fa-truck"></i>
      </div>
        <span class="hover-note">Hover for more info</span>
      </div></div>
      <div class="ob__results__li ob__results--flex3 ob--justify-start" data-label="Description">
        <div class="js--li-body">
          <p class="ob__results__text"><span class="ob__results--bold">${FullPartNumber}</span> ${Description}</p>
          <div class="ship-method eta${ETADate ? '' : ' hide-method'
        }"><span class="ob__results--bold">ETA:</span><span>\u00A0${ETADate}</span></div>
          ${PackageNotes && PackageNotes.length > 0
            ? `<p class="ob__results__text"><span class="ob__results--bold">Package Notes: </span>${PackageNotes}</p>`
            : ''
        }
          ${AlternateWarehouseNote && AlternateWarehouseNote.length > 0
            ? `<p class="ob__results__text"><span class="ob__results--bold">Note: </span>${AlternateWarehouseNote}</p>`
            : ''
        }
          ${displayNoteEdit && !IsNLA
            ? PartNote && PartNote.length
                ? `<p class="ob__results__text"><span class="ob__results--bold">Part Notes: </span><span class="js--upload-note">${PartNote}</span><button class="ob__results__edit js--add-note"><i class="fas fa-pencil-square-o" aria-hidden="true"></i></button></p>`
                : '<button class="ob__results__text ob__results__button js--add-note">Add Individual Part Notes</button>'
            : ''
        }
          ${viewNote && PartNote && PartNote.length
            ? `<p class="ob__results__text"><span class="ob__results--bold">Part Notes: </span>${PartNote}</p>`
            : ''
        }
          <div class="ob__results__note-container none js--note">
            <textarea class="ob__results__textarea js--note-body" placeholder="Enter Part Note" data-id="${Id}">${PartNote || ''
        }</textarea>
            <p class="ob__results__text ob__results__note-options">
              <button class="ob__results__button ob__results__cancel js--note-cancel">Cancel</buttonclass>
              <button class="ob__results__button ob__results__save js--note-save" data-qty="${qty}" data-id="${Id}">Save</button>
            </p>
          </div>
        </div>
      </div>
      ${del
            ? `<div class="ob__results__li ob--tc" data-label="Qty.">
            <input tabindex="-1" class="ob--center js--ob-li-qty" type="text" name="qty" value="${qty}" data-id="${Id}">
          </div>`
            : `<div class="ob__results__li ob--tc" data-label="Qty.">${qty}</div>`
        }
      <div class="ob__results__li" data-label="Cost">${formatMoney(ActualCost)}</div>
      <div class="ob__results__li" data-label="Total">${formatMoney(ActualCost * qty)}</div>
      ${!del
            ? `<div class="ob__results__remove"></div>`
            : `<button class="ob__results__remove ob__overview__clear js--ob-remove" data-id="${Id}">
        <i class="fas fa-times-circle" aria-hidden="true"></i>
      </button>`
        }
    </div>`;
}

// ==================================================
// INIT
// ==================================================
const init = () => {
    const _atcBtn = document.getElementsByClassName('js--ob-atc')[0];
    document.addEventListener('submit', (e) => e.preventDefault());

    if (_search) {
        _searchAtcBtn.addEventListener('click', () => productATC());
        _dropdown.addEventListener('click', (e) => handleDropdownClick(e));
        _atcBtn.addEventListener('click', () => addProductToCart());
        _clear.addEventListener('click', (e) => {
            e.preventDefault();
            clearItems();
        });

        Array.from(['keyup', 'change']).forEach((k) =>
            _search.addEventListener(k, (e) =>
                [13, 38, 40].indexOf(e.keyCode) === -1 ? handleChange(e) : handleKeys(e),
            ),
        );

        _qty.addEventListener('keydown', (e) => qtyTabATC(e));
        _qty.addEventListener('keyup', (e) => checkQtyVal(e));
        _qty.addEventListener('focus', () => checkForProductId());

        displayInactiveCartItems();
    }

    document.addEventListener('click', (e) =>
        e.target.classList.contains('js--alt-parts') ? listPart(e) : false,
    );

    noItems = document.getElementsByClassName('js--ob-no-items')[0].cloneNode(true);
};

export default init;
